var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('b-modal', {
    attrs: {
      "visible": _vm.show,
      "title": "Detalhe da execução",
      "size": "xl",
      "centered": "",
      "hide-footer": ""
    },
    on: {
      "hidden": function hidden($event) {
        return _vm.$emit('close');
      }
    }
  }, [_vm.execucao ? _c('div', [_c('div', {
    staticClass: "d-flex justify-content-between align-items-start mb-5"
  }, [_c('div', [_c('h5', {
    staticClass: "font-weight-bolder mb-2"
  }, [_vm._v(" Competência " + _vm._s(_vm.execucao.competencia) + " ")]), _c('div', {
    staticClass: "text-muted"
  }, [_vm._v(" " + _vm._s(_vm.formatPeriodo(_vm.execucao.data_inicial, _vm.execucao.data_final)) + " ")])]), _c('StatusBadge', {
    attrs: {
      "status": _vm.execucao.status
    }
  })], 1), _c('b-row', {
    staticClass: "mb-5"
  }, [_c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('strong', [_vm._v("Tipo de execução")]), _c('p', [_vm._v(_vm._s(_vm.labelTipoExecucao(_vm.execucao.tipo_execucao)))])]), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('strong', [_vm._v("Início")]), _c('p', [_vm._v(_vm._s(_vm.formatDateTime(_vm.execucao.iniciado_em)))])]), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('strong', [_vm._v("Fim")]), _c('p', [_vm._v(_vm._s(_vm.formatDateTime(_vm.execucao.finalizado_em)))])]), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('strong', [_vm._v("Tamanho do pacote")]), _c('p', [_vm._v(_vm._s(_vm.formatBytes(_vm.execucao.zip_size)))])])], 1), _vm.execucao.erro ? _c('b-alert', {
    attrs: {
      "show": "",
      "variant": "warning"
    }
  }, [_vm._v(" " + _vm._s(_vm.execucao.erro) + " ")]) : _vm._e(), _c('div', {
    staticClass: "d-flex justify-content-end mb-4"
  }, [_c('button', {
    staticClass: "btn btn-light-primary mr-2",
    attrs: {
      "type": "button",
      "disabled": !_vm.temPacote
    },
    on: {
      "click": function click($event) {
        return _vm.$emit('download', _vm.execucao);
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-download mr-1"
  }), _vm._v(" Baixar pacote ")]), _c('button', {
    staticClass: "btn btn-light",
    attrs: {
      "type": "button",
      "disabled": !_vm.temPacote
    },
    on: {
      "click": function click($event) {
        return _vm.$emit('resend', _vm.execucao);
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-envelope mr-1"
  }), _vm._v(" Reenviar e-mail ")])]), _c('h6', {
    staticClass: "font-weight-bolder"
  }, [_vm._v("Arquivos gerados")]), _c('div', {
    staticClass: "table-responsive mb-5"
  }, [_c('table', {
    staticClass: "table table-sm table-striped"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Tipo")]), _c('th', [_vm._v("Arquivo")]), _c('th', [_vm._v("Status")]), _c('th', [_vm._v("Erro")])])]), _c('tbody', [_vm._l(_vm.arquivos, function (arquivo) {
    return _c('tr', {
      key: arquivo.id
    }, [_c('td', [_vm._v(_vm._s(arquivo.tipo))]), _c('td', [_vm._v(_vm._s(arquivo.nome_arquivo || "-"))]), _c('td', [_vm._v(_vm._s(_vm.labelStatusArquivo(arquivo.status)))]), _c('td', [_vm._v(_vm._s(arquivo.erro || "-"))])]);
  }), _vm.arquivos.length === 0 ? _c('tr', [_c('td', {
    staticClass: "text-muted text-center",
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v(" Nenhum arquivo registrado. ")])]) : _vm._e()], 2)])]), _c('h6', {
    staticClass: "font-weight-bolder"
  }, [_vm._v("Logs de e-mail")]), _c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table table-sm table-striped"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("E-mail")]), _c('th', [_vm._v("Tipo")]), _c('th', [_vm._v("Status")]), _c('th', [_vm._v("Enviado em")]), _c('th', [_vm._v("Erro")])])]), _c('tbody', [_vm._l(_vm.emailLogs, function (log) {
    return _c('tr', {
      key: log.id
    }, [_c('td', [_vm._v(_vm._s(log.email))]), _c('td', [_vm._v(_vm._s(_vm.labelTipoEmail(log.tipo)))]), _c('td', [_vm._v(_vm._s(_vm.labelStatusEmailLog(log.status)))]), _c('td', [_vm._v(_vm._s(_vm.formatDateTime(log.sent_at)))]), _c('td', [_vm._v(_vm._s(log.erro || "-"))])]);
  }), _vm.emailLogs.length === 0 ? _c('tr', [_c('td', {
    staticClass: "text-muted text-center",
    attrs: {
      "colspan": "5"
    }
  }, [_vm._v(" Nenhum log de e-mail registrado. ")])]) : _vm._e()], 2)])])], 1) : _vm._e()]);
};
var staticRenderFns = [];
export { render, staticRenderFns };